import './index.sass';

export default () => {
  $(document).on('ajax:success', '.js-add-friends', function(e) {
    if (e.detail[0].follow) {
      return $(this).addClass('user-item__btn--check').attr('data-method', 'delete').data('method', 'delete').attr('href', e.detail[0].path);
    } else {
      return $(this).removeClass('user-item__btn--check').attr('data-method', 'post').data('method', 'post').attr('href', e.detail[0].path);
    }
  });
}